import CryptoJS from "crypto-js";

export function isMobile() {
  if (window.innerWidth < 900) {
    return true;
  } else {
    return false;
  }
}

export function generateHashData(id: string, reqDate: string) {
  const SECRET_KEY =
    "PbpwBC4hRuMxAztw9p85L7K+SB7Iswd1tdRwca7xQ2sFftC5nYAFgYkOctQ1ubHzACV0YzaWHJdqWAGZW34kPw==";
  const raw = id + reqDate + SECRET_KEY;
  return CryptoJS.SHA256(raw).toString(CryptoJS.enc.Hex);
}
